import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import moment from 'moment';
import { CountryService } from '../../../shared/services/country.service';
import { DepartmentInterface } from '../../../shared/models/department.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { DomSanitizer} from '@angular/platform-browser';
import { MatIconRegistry} from '@angular/material/icon';
import { environment} from '../../../../../environments/environment';
import { CustomerService } from '../../../account/services/customer.service';
import { select, Store } from '@ngrx/store';
import { GetAlertMessage } from '../../../shared/store/actions/alert-message.actions';
import { MsisdnListInterfaceState } from '../../../lines/store/state/msisdn-list.state';
import { GetMsisdnList } from '../../../lines/store/actions/msidn-list.actions';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { ExtranetService } from '../../../shared/services/extranet.service';

@Component({
  selector: 'app-account-information',
  templateUrl: './account-information.component.html',
  styleUrls: ['./account-information.component.css'],
  standalone: false
})
export class AccountInformationComponent implements OnInit {

  @Output()
  accountInformation = new EventEmitter<any>();

  form: FormGroup;
  formSubmitted: boolean;
  startDate: string = moment(new Date()).subtract('18', 'y').format('YYYY-MM-DD');
  endDate: string = moment(new Date()).subtract('110', 'y').format('YYYY-MM-DD');
  departments: Array<DepartmentInterface>;
  errors: any = {
    lastName: {
      required: `Le nom est obligatoire.`,
      pattern: `Veuillez saisir un nom sans accent, caractères spéciaux ni chiffres.`
    },
    firstName: {
      required: `Le prénom est obligatoire.`,
      pattern: `Veuillez saisir un nom sans accent, caractères spéciaux ni chiffres.`
    },
    email: {
      required: `L'adresse email est obligatoire.`,
      pattern: `L'adresse email saisie n'est pas valide.`
    },
    birthDate: {
      required: `La date de naissance est obligatoire.`,
      pattern : `Le format de date est invalide.`
    },
    birthDepartment: {
      required: `Le département de naissance est obligatoire.`,
    },
    phoneNumber: {
      required: `Le numéro de téléphone est obligatoire.`,
      pattern: `Ce champ requiert une suite de 10 caractères numériques commençant par 01, 02, 03, 04, 05 ou 06 ou 07 ou 09.`
    },
  };
  brand = environment.data.brand;
  invalidBirthDate: boolean;
  displayPromo: boolean;
  acceptPromo: boolean;
  supportUser: SupportUserInterface;

  constructor(
      private formBuilder: FormBuilder,
      private countryService: CountryService,
      private domSanitizer: DomSanitizer,
      private matIconRegistry: MatIconRegistry,
      private customerService: CustomerService,
      private extranetService: ExtranetService,
      public store: Store<any>
  ) {}

  ngOnInit() {
    this.supportUser = this.extranetService.getSupportUser();
    this.store.dispatch(new GetMsisdnList());
    this.displayPromo = false;
    this.acceptPromo = false;
    this.formSubmitted = false;
    this.invalidBirthDate = false;
    this.departments = [];
    this.countryService.getDepartments().subscribe(res => {
      this.departments = res;
      this.initForm();
    });
    this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
      if (response.list instanceof Array && response.list.length > 0) {
        this.customerService.getReport(response.list[0].phoneNumber).subscribe(report => {
          this.displayPromo = report.length > 0 || this.supportUser !== null;
        });
      }
    });
    this.matIconRegistry.addSvgIcon(
        'agenda',
        this.domSanitizer.bypassSecurityTrustResourceUrl(
            '../../../../../../../assets/images/icons/' + this.brand + '_small-agenda.svg'
        )
    );
  }

  initForm() {
    this.form = this.formBuilder.group({});
    this.form = new FormGroup({
      civility: new FormControl('Mme', Validators.required),
      lastName: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.lastNamePattern)]),
      firstName: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.firstNamePattern)]),
      email: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.emailPattern)]),
      birthDate: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.frenchDatePattern)]),
      birthDepartment: new FormControl('Choisir un département', [Validators.required]),
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern(ConstsHelper.phonePattern)]),
    });
  }

  submit() {
    this.formSubmitted = true;
    this.invalidBirthDate = false;
    if (this.form.valid) {
      if (
          moment(this.form.get('birthDate').value, 'DD/MM/YYYY').diff(moment(this.startDate, 'YYYY-MM-DD'), 'days') > 0||
          moment(this.form.get('birthDate').value, 'DD/MM/YYYY').diff(moment(this.endDate, 'YYYY-MM-DD'), 'days') < 0
      ) {
        this.invalidBirthDate = true;
      } else {
        this.customerService.checkEmailValidity(this.form.get('email').value).subscribe(response => {
          const accountInformation = {
            civility: this.form.get('civility').value,
            lastName: this.form.get('lastName').value,
            firstName: this.form.get('firstName').value,
            email: this.form.get('email').value,
            birthDate: this.form.get('birthDate').value,
            birthDepartment: this.form.get('birthDepartment').value,
            phoneNumber: this.form.get('phoneNumber').value,
            acceptPromo: this.acceptPromo
          };
          this.accountInformation.emit(accountInformation);
        }, error => {
          this.store.dispatch(new GetAlertMessage({
            message: 'L\'email est utilisé par un autre client.',
            code: 400
          }));
        });
      }
    }
  }

  handleManualInput(date: string) {
    this.form.get('birthDate').setValue(date);
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.form.controls[formControlName].invalid) {
      Object.keys(this.form.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }

  setPromoResponse($event) {
    this.acceptPromo = $event.target.checked;
  }
}
